import { v4 as uuidv4 } from 'uuid';
import { I18n } from '@aws-amplify/core';
import React, { useEffect } from 'react';
import { Checkbox as AntCheckbox, Col, Form, Row } from 'antd';

import { AditionalItemProps } from './types';
import { Text } from '@/components/Typography';
import { AdditionalItemsResults } from '@/hooks';
import { useStepKeysContext } from '../DefaultSelects/context';

const { useFormInstance, useWatch } = Form;

const CHECKED_VALUE = 1;
const UNCHECKED_VALUE = 0;

export function Checkbox({ additionalItem }: Readonly<AditionalItemProps>): JSX.Element {
	const { id, title_1 } = additionalItem;

	const form = useFormInstance();
	const { formFieldName } = useStepKeysContext();

	const isChecked = useWatch([...formFieldName, 'additional_items', id, 'value_1']);

	useEffect(() => {
		const result: AdditionalItemsResults[] = [
			{
				id: uuidv4(),
				value_1: isChecked ? CHECKED_VALUE : UNCHECKED_VALUE,
				result: 0
			}
		];

		form.setFieldValue([...formFieldName, 'additional_items', id, 'results'], result);
	}, [isChecked]);

	return (
		<Row gutter={[0, 15]} key={id} style={{ marginRight: '2rem' }}>
			<Col span={24}>
				<Form.Item
					style={{ margin: 0 }}
					valuePropName="checked"
					name={[...formFieldName, 'additional_items', id, 'value_1']}
				>
					<AntCheckbox>
						<Text>{I18n.get(title_1)}</Text>
					</AntCheckbox>
				</Form.Item>
			</Col>
		</Row>
	);
}
